// Each tenant's own document numbers, formatted the same way as the server
// (backend/flask_app/api/doc_numbers.py): PO-0001, GR-0001, ...
// Raw database ids stay in URLs only; people see these.
const PREFIXES = {
  po: 'PO',
  receipt: 'GR',
  return: 'VR',
  bill: 'BILL',
  sale: 'SALE',
  refund: 'RF',
  customerPayment: 'CP',
  vendorPayment: 'VP',
  je: 'JE',
}

export const docNo = (kind, n) => (n === null || n === undefined || n === '' ? '' : `${PREFIXES[kind]}-${String(n).padStart(4, '0')}`)
